export default __webpack_public_path__ + "static/media/ilawNew.d82ebd8e.png";